import React, { useState } from "react";
import { useGameContext } from "GameContext";
import { useWebSocket } from "WebSocketContext";

export default function GameControls() {
  const { socket } = useWebSocket();
  const {
    currentStage,
    gameId,

    currentYear,
    yearCount,
    connectedIds,
    timeLeft,
    isTimerPaused,
    gameEnded,
    downloadGameData,
  } = useGameContext() as any;


  function pause() {
    if (gameEnded) return;

    const mes = JSON.stringify({
      kind: "Pause",
      toIds: connectedIds,
    });
    socket?.send( mes );
  }
  function resume() {
    if (gameEnded) return;

    const mes = JSON.stringify({
      kind: "Resume",
      toIds: connectedIds,
    });
    socket?.send( mes );
  }

  function setNewTime(seconds: number) {
    if (gameEnded) return;

    const mes = JSON.stringify({
      kind: "UpdateTimer",
      toIds: connectedIds,
      newTime: seconds,
    });
    socket?.send( mes );
  }

  const adjustTime = (offset: number) => {
    setNewTime(Math.max(0, offset+timeLeft));
  };

  const formatTime = (s: number) => {
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return `${m}:${sec.toString().padStart(2, "0")}`;
  };

  // TODO DOWNLOAD GAME DATA

  return (
    <div className="flex flex-col p-4">
      <div className="space-y-4">
        <div className="space-y-1 text-sm">
          <p>Current Year: {currentYear}</p>
          <p>Current Stage: {currentStage}</p>
          <p>Game Length: {yearCount}</p>
          <p>Years Left to do: {yearCount - currentYear}</p>
        </div>

        <div className="flex items-center gap-2">
          <span>Manually Control:</span>
          <button
            className="px-3 py-1 rounded-lg border border-black hover:bg-black/5"
            onClick={() => {
              setNewTime(0);
            }}
          >
            { currentStage === "vote" ? (
              "Send players back to game (Progresses a year)"
            ) : (
              "Send players to voting hall"
            )}
          </button>
        </div>

        <div className="border border-black rounded-lg p-3 text-center">
          <p className="mb-2">Game Time Left: {formatTime(timeLeft)}</p>
          <div className="flex flex-wrap justify-center gap-2">
            <button
              onClick={() => adjustTime(-600)}
              className="px-2 py-1 rounded-lg border border-black hover:bg-black/5"
            >
              -10min
            </button>
            <button
              onClick={() => adjustTime(-300)}
              className="px-2 py-1 rounded-lg border border-black hover:bg-black/5"
            >
              -5min
            </button>
            <button
              onClick={() => adjustTime(-60)}
              className="px-2 py-1 rounded-lg border border-black hover:bg-black/5"
            >
              -1min
            </button>
            <button
              onClick={() => adjustTime(-30)}
              className="px-2 py-1 rounded-lg border border-black hover:bg-black/5"
            >
              -30s
            </button>

            { isTimerPaused ? (
              <button onClick={resume}>Resume</button>
            ) : (
              <button onClick={pause}>Pause</button>
            )}

            <button
              onClick={() => adjustTime(30)}
              className="px-2 py-1 rounded-lg border border-black hover:bg-black/5"
            >
              +30s
            </button>
            <button
              onClick={() => adjustTime(60)}
              className="px-2 py-1 rounded-lg border border-black hover:bg-black/5"
            >
              +1min
            </button>
            <button
              onClick={() => adjustTime(300)}
              className="px-2 py-1 rounded-lg border border-black hover:bg-black/5"
            >
              +5min
            </button>
            <button
              onClick={() => adjustTime(600)}
              className="px-2 py-1 rounded-lg border border-black hover:bg-black/5"
            >
              +10min
            </button>
          </div>
        </div>
      </div>

      <div className="space-x-2 mt-4">
        <button className="px-3 py-1 rounded-lg border border-black hover:bg-black/5" onClick={downloadGameData}>
          Download Game Data
        </button>
      </div>
    </div>
  );
}
